import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import { Button } from '@mui/joy';
import Modal from '@mui/material/Modal';
import { CircularProgress, MenuItem, Select } from '@mui/material';
import styles from "./etcstyle/facerecognitionmodalstyle.module.css";
import totalLocationData from "../../../../data/locationdata";
import { getFetch, postFetch } from "../../../../fetch/fetch";
import { koreanLocationToEnglish } from "../../../../data/locationFuntion";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: "16px",
    boxShadow: 24,
    p: 3,
    paddingLeft: 5,
    paddingRight: 5
};

interface FaceRecognitionModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    selectedUserFingerprintId: number | undefined;
    selectedUserLocation: string | null;
    selectedUserName: string | undefined;
    notify1: () => void;
    user: any;
}


const FaceRecognitionModal: React.FC<FaceRecognitionModalProps> = (props) => {

    const [photoShootLoading, setPhotoShootLoading] = useState(false);
    const [photoShootData, setPhotoShootData] = useState<any>(null);

    const [photoSaveLoading, setPhotoSaveLoading] = useState(false);

    const [visualFaces, setVisualFaces] = useState<any>([]);
    const [faceLoading, setFaceLoading] = useState(false);

    const [selectedFaceDevice, setSelectedFaceDevice] = useState("");
    const [faceDeviceNames, setFaceDeviceNames] = useState<any>({});   //지점별 설정된 얼굴 등록 장치명 { [english location]: name }

    useEffect(() => {

        if (props.open && props.selectedUserFingerprintId) {
            getFaceImages();
        }

    }, [props.open, props.selectedUserFingerprintId]);

    const deleteUserImage = async () => {

        try {

            if (!props.selectedUserFingerprintId) {
                return;
            }

            if (!window.confirm("정말로 삭제하시겠습니까?")) {
                return;
            }

            setFaceLoading(true);

            const result: any = await postFetch("/dashboard/avatar/deleteuserimage", {
                fingerprintId: props.selectedUserFingerprintId
            });

            if (result.message === "success") {
                setVisualFaces([]);
                props.setOpen(false);
                props.notify1();
            }

            setFaceLoading(false);

        } catch (e) {
            console.log(e);
            setFaceLoading(false);
        }

    }

    useEffect(() => {

        //촬영 장비 기본값은 학생 지점이 아니라 로그인 선생님 지점 기준 (운영진처럼 지점이 없으면 학생 지점으로 폴백)
        const teacherEnglish = props.user && props.user.location ? koreanLocationToEnglish(props.user.location) : undefined;

        if (teacherEnglish && teacherEnglish !== "total") {
            setSelectedFaceDevice(teacherEnglish);
            return;
        }

        if (!props.selectedUserLocation) {
            setSelectedFaceDevice("");
            return;
        }

        const englishLocation = koreanLocationToEnglish(props.selectedUserLocation);

        if (!englishLocation) {
            setSelectedFaceDevice("");
            return;
        }

        setSelectedFaceDevice(englishLocation);

    }, [props.open, props.user, props.selectedUserLocation]);

    const letsPhotoShoot = async () => {
        try {

            if (!selectedFaceDevice) {
                return;
            }

            setPhotoShootLoading(true);

            const result: any = await getFetch("/dashboard/avatar/letsphotoshoot?selectedFaceDevice=" + selectedFaceDevice);

            setPhotoShootLoading(false);

            if (result.message === "success") {

                console.log(result);

                const data = result.data.credentials.faces;

                const editedData = {
                    credentials: {
                        visualFaces: data
                    }
                }

                setPhotoShootData(editedData);

            }

        } catch (e) {
            console.log(e);
        }
    }

    const savePhoto = async () => {
        try {

            if (!photoShootData || !props.selectedUserFingerprintId) {
                return;
            }

            setPhotoSaveLoading(true);

            const result: any = await postFetch("/dashboard/avatar/uploadbiostarshootingimage", {
                fingerprintId: props.selectedUserFingerprintId,
                data: photoShootData
            });

            setPhotoSaveLoading(false);

            if (result.message === "success") {
                props.notify1();
                props.setOpen(false);
            }

        } catch (e) {
            console.log(e);
            setPhotoSaveLoading(false);
        }
    }

    const getFaceImages = async () => {

        try {

            setFaceLoading(true);

            //얼굴 이미지와 함께 지점별 인증 등록장치 설정(얼굴 장치명 표시용)도 같이 받음 — 설정 조회 실패는 무시
            const [result, settingResult]: any = await Promise.all([
                getFetch("/dashboard/avatar/getstudentfaces?fingerprintId=" + props.selectedUserFingerprintId),
                getFetch("/dashboard/biostarenroll/settings").catch(() => null)
            ]);

            if (settingResult && settingResult.message === "success" && Array.isArray(settingResult.data)) {
                const names: any = {};
                settingResult.data.forEach((row: any) => {
                    if (row.faceDeviceName) {
                        names[row.location] = row.faceDeviceName;
                    }
                });
                setFaceDeviceNames(names);
            }

            console.log(result);

            if (result.message === "success") {

                const visualFaces = result.data.User.credentials?.visualFaces;

                if (!visualFaces) {
                    setFaceLoading(false);
                    return;
                }

                const newVisualFaces: any = [];

                visualFaces.forEach((each: any) => {

                    const image = each.template_ex_normalized_image;

                    newVisualFaces.push(image);

                });

                setVisualFaces([...newVisualFaces]);

            }

            setFaceLoading(false);

        } catch (e) {
            console.log(e);
            setFaceLoading(false);
        }

    }

    return (
        <Modal
            open={props.open}
            onClose={() => {
                // setOpen9(false);
                props.setOpen(false);
                setVisualFaces([]);
                setFaceLoading(false);
                setSelectedFaceDevice("");
                setPhotoShootLoading(false);
                setPhotoShootData(null);
            }}
        >
            <Box sx={style}>
                {
                    faceLoading ?
                        <Box sx={{
                            width: '100%', marginTop: 3, marginBottom: 3,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                            <CircularProgress />
                        </Box>
                        :
                        ""
                }
                {
                    !faceLoading && visualFaces.length > 0 ?
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                            <div style={{
                                fontFamily: "Apple_B",
                                fontSize: "18px",
                                marginBottom: "16px"
                            }}>
                                얼굴 인증 내역 ({props.selectedUserName})
                            </div>
                            {
                                visualFaces.map((each: any, index: any) => {
                                    return (
                                        <div key={index} style={{ marginBottom: "18px" }}>
                                            <img src={`data:image/jpeg;base64,${each}`} alt="face" />
                                        </div>
                                    )
                                })
                            }
                            <Button
                                fullWidth
                                sx={{ marginTop: "12px" }}
                                variant="solid"
                                color="neutral"
                                onClick={deleteUserImage}
                                disabled={faceLoading || visualFaces.length === 0}
                            >
                                인증 얼굴 삭제하기
                            </Button>
                        </div>
                        :
                        ""
                }
                {
                    !faceLoading && visualFaces.length === 0 ?
                        <div>
                            <div>
                                <div style={{
                                    fontFamily: "Apple_B",
                                    fontSize: "18px",
                                    marginBottom: "16px"
                                }}>
                                    얼굴 인증 등록하기 ({props.selectedUserName})
                                </div>
                                {
                                    !photoShootData ?
                                        <>
                                            <div style={{ marginTop: "8px", fontFamily: "Apple_SB" }} className={styles.messageTitle}>
                                                촬영 장비 선택
                                            </div>
                                            <div className={styles.textfieldDiv}
                                                style={{
                                                    marginTop: "9px"
                                                }}
                                            >
                                                <Select value={selectedFaceDevice}
                                                    fullWidth
                                                    size="small"
                                                    placeholder='지점 선택'
                                                    onChange={(e: any) => {
                                                        setSelectedFaceDevice(e.target.value);;
                                                    }}
                                                >
                                                    {props.user && totalLocationData.filter((each) => each.academy.includes(props.user.academy)).map((each, index) => {

                                                        if (each.english === "total") {
                                                            return null;
                                                        }

                                                        if (each.english === "songdo_free") {
                                                            return;
                                                        }

                                                        if (each.english === "get50" || each.english === "getL") {
                                                            return;
                                                        }

                                                        //지점별 설정에 얼굴 장치가 있으면 그 이름, 없으면 기존 입문/출문 장비
                                                        return (
                                                            <MenuItem value={`${each.english}`} key={index}>{each.korean} · {faceDeviceNames[each.english] ? faceDeviceNames[each.english] : `${each.needOutside ? "입문" : "출문"} 장비`}</MenuItem>
                                                        )
                                                    })
                                                    }
                                                </Select>
                                            </div>
                                        </>
                                        :
                                        ""
                                }

                                {
                                    photoShootData &&
                                    <div style={{ marginTop: "24px", display: "flex", justifyContent: "center" }}>
                                        <img src={`data:image/jpeg;base64,${photoShootData.credentials.visualFaces[0].template_ex_normalized_image}`} alt="preview" />
                                    </div>
                                }
                                {
                                    !photoShootData
                                        ?
                                        <Button
                                            fullWidth
                                            sx={{ marginTop: "18px" }}
                                            variant="solid"
                                            color="neutral"
                                            onClick={letsPhotoShoot}
                                            disabled={!selectedFaceDevice || faceLoading || photoShootLoading}
                                            loading={photoShootLoading}
                                        >
                                            촬영하기
                                        </Button>
                                        :
                                        <Button
                                            fullWidth
                                            sx={{ marginTop: "18px" }}
                                            variant="solid"
                                            color="primary"
                                            onClick={savePhoto}
                                            disabled={photoSaveLoading}
                                            loading={photoSaveLoading}
                                        >
                                            사진 저장하기
                                        </Button>

                                }


                            </div>
                        </div>
                        :
                        ""
                }

            </Box>
        </Modal>
    )

};

export default FaceRecognitionModal;